var App = App || {};

App.SoloAccess = (function ($, ko) {
	"use strict";

	const ADMIN_SKU = "DB-ADM-EZPLUS";

	function Product(data) {
		data = data || {};
		var self = this;

		this.key = ko.observable(data.key || "");
		this.sku = ko.observable(data.sku || "");
		this.title = ko.observable(data.title || "");
		this.description = ko.observable(data.description || "");
		this.price = ko.observable(Number(data.price || 0.0));
		this.currency = ko.observable(data.currency || "USD");
		this.url = ko.observable(data.url || "");
		this.contentType = ko.observable(data.contentType || "");
		this.properties = ko.observable(data.properties || {});
		this.variants = ko.observableArray(
			(Array.isArray(data.bundleOptions) ? data.bundleOptions : []).map(function (variant) {
				return new Product(variant);
			})
		);

		this.formattedPrice = ko.pureComputed(() => formatCurrency(self.price(), ko.unwrap(self.currency), "en-US"));
		this.isAdmin = ko.pureComputed(() => self.sku() === ADMIN_SKU);
	}

	function SoloCatalog() {
		this.product = ko.observable(new Product());
		this.addon = ko.observable(new Product());
		this.databases = ko.observableArray([]);


		this.reducedVariant = ko.pureComputed(() =>
			this.product()?.variants()?.find(v => v.sku() === "MBR-ATTY-RED") || {}
		);

		this.fullVariant = ko.pureComputed(() =>
			this.product()?.variants()?.find(v => v.sku() === "MBR-ATTY-FULL") || {}
		);
	}

	const validityPulse = ko.observable(0);

	const viewModel = {
		soloCatalog: new SoloCatalog(),
		form: {
			selectedVariant: ko.observable(null),
			acceptTerms: ko.observable(false),
			firstName: ko.observable(""),
			lastName: ko.observable(""),
			email: ko.observable(""),
			username: ko.observable(""),
			password: ko.observable(""),
			confirmPassword: ko.observable(""),
			firm: ko.observable(""),
			address: ko.observable(""),
			city: ko.observable(""),
			state: ko.observable(""),
			postalCode: ko.observable(""),
			phone: ko.observable(""),
			source: ko.observable(""),
			selectedDatabaseProducts: ko.observableArray([]),
			selectedAddOns: ko.observableArray([])
		},
		net: {
			usernameXhr: null,
			emailXhr: null
		},
		ui: {
			databasesExpanded: ko.observable(false),
			databasesVisibleCount: ko.observable(6),
			expandDatabases: function () { this.ui.databasesExpanded(true); },
			collapseDatabases: function () { this.ui.databasesExpanded(false); }
		},
		pricing: {
			currency: "USD"
		},
		actions: {}
	};

	viewModel.form.proprietorSelected = ko.pureComputed({
		read: function () {
			const addOn = viewModel.soloCatalog.addon();
			if (!addOn || !addOn.key) return false;
			const key = ko.unwrap(addOn.key);
			return this.selectedAddOns().some(p => p.key() === key);
		},
		write: function (checked) {
			const addOn = viewModel.soloCatalog.addon();
			if (!addOn || !addOn.key) return;
			const key = ko.unwrap(addOn.key);
			const exists = this.selectedAddOns().some(p => p.key() === key);

			if (checked && !exists) {
				this.selectedAddOns.push(addOn);
			} else if (!checked && exists) {
				this.selectedAddOns.remove(p => p.key() === key);
			}
		},
		owner: viewModel.form
	});

	viewModel.form.bundledItems = ko.pureComputed(function () {
		const dbs = this.form.selectedDatabaseProducts() || [];
		const addOns = this.form.selectedAddOns ? this.form.selectedAddOns() : [];
		return addOns.concat(dbs);
	}, viewModel);

	viewModel.pricing.membershipFee = ko.pureComputed(function () {
		const variant = this.form.selectedVariant();
		return variant ? Number(variant.price()) : 0;
	}, viewModel);

	viewModel.pricing.databasesTotal = ko.pureComputed(function () {
		return this.form.selectedDatabaseProducts()
			.reduce((sum, product) => sum + Number(product.price()), 0);
	}, viewModel);

	viewModel.pricing.addOnsTotal = ko.pureComputed(function () {
		return this.form.bundledItems()
			.reduce((sum, product) => sum + Number(product.price()), 0);
	}, viewModel);

	viewModel.pricing.subtotal = ko.pureComputed(function () {
		return this.pricing.membershipFee() + this.pricing.addOnsTotal();
	}, viewModel);

	viewModel.pricing.formattedMembershipFee = ko.pureComputed(function () {
		return formatCurrency(this.pricing.membershipFee(), this.pricing.currency);
	}, viewModel);

	viewModel.pricing.formattedDatabasesTotal = ko.pureComputed(function () {
		return formatCurrency(this.pricing.databasesTotal(), this.pricing.currency);
	}, viewModel);

	viewModel.pricing.formattedSubtotal = ko.pureComputed(function () {
		return formatCurrency(this.pricing.subtotal(), this.pricing.currency);
	}, viewModel);

	viewModel.form.isProfileValid = ko.pureComputed(function () {
		this.firstName();
		this.lastName();
		this.email();
		this.username();
		this.password();
		this.confirmPassword();
		this.firm();
		this.address();
		this.state();
		validityPulse();
		const profileFormElement = document.getElementById("member-profile-form");
		return !!profileFormElement && profileFormElement.checkValidity();
	}, viewModel.form);

	viewModel.form.adminSelected = ko.pureComputed(function () {
		return this.selectedDatabaseProducts()?.some(p => p.isAdmin());
	}, viewModel.form);

	viewModel.form.selectedDatabaseProducts.subscribe(function (list) {
		const admin = list.find(p => p.isAdmin());
		if (admin && list.length > 1) {
			viewModel.form.selectedDatabaseProducts([admin]);
		}
	});

	viewModel.ui.databasesLabel = ko.pureComputed(function () {
		const items = this.form.selectedDatabaseProducts();
		const hasAdmin = items.some(p => p.isAdmin());

		if (hasAdmin)
			return "All Administrative Databases";

		return items.length ? `${items.length} Administrative database${items.length > 1 ? "s" : ""}` : "No administrative databases";
	}, viewModel);

	viewModel.ui.databasesTokens = ko.pureComputed(function () {
		const hasAdmin = this.form.selectedDatabaseProducts()?.some(p => p.isAdmin());

		if (hasAdmin)
			return "";

		return this.form.selectedDatabaseProducts()
			.map(product => product.properties().token)
			.filter(Boolean)
			.join(", ");
	}, viewModel);

	viewModel.actions.submit = function (data, event) {

		if (viewModel.net.usernameXhr || viewModel.net.emailXhr) {
			announce('Please wait, still checking your entries.');
			event.preventDefault();
			return;
		}
		var formEl = document.getElementById('member-profile-form');
		if (formEl && !formEl.checkValidity()) {
			event.preventDefault();
			(formEl.querySelector('.is-invalid, :invalid') || formEl).focus();
			announce('There are errors on the form. Focus moved to the first issue.');
			return;
		}

		const bundleItems = viewModel.form.bundledItems().map((item) =>
		({
			product: item.key(),
			productVariant: null,
			quantity: 1,
			userData: { "cartDescription": item.title() }
		}));

		const userData = {
			"registrationData": {
				firstName: viewModel.form.firstName(),
				lastName: viewModel.form.lastName(),
				email: viewModel.form.email(),
				username: viewModel.form.username(),
				password: viewModel.form.password(),
				firm: viewModel.form.firm(),
				address: viewModel.form.address(),
				city: viewModel.form.city(),
				state: viewModel.form.state(),
				postalCode: viewModel.form.postalCode(),
				phone: viewModel.form.phone(),
				source: viewModel.form.source()
			}
		};

		var $finishBtn = $(event.currentTarget);
		App.Spinner.startSpinner($finishBtn, "Processing");

		App.Commerce.Bundle(
			viewModel.soloCatalog.product().key(),
			viewModel.form.selectedVariant().key(),
			1,
			bundleItems,
			userData
		).done(function () {
			window.location.href = "/shopping-cart/"
		}).fail(function () {
			App.Spinner.stopSpinner($finishBtn);
		});
	};

	function fetchProduct(key) {
		return $.ajax({
			url: "/api/products/" + key,
			method: "GET",
			dataType: "json"
		}).then((response) => {
			if (!response || response.success === false) {
				return $.Deferred().reject(response && response.message || "Unknown error");
			}
			return response.data;
		});
	}

	function fetchCategory(key) {
		if (!key)
			return $.Deferred().resolve([]);

		return $.ajax({
			url: "/api/products/category/" + key,
			method: "GET",
			dataType: "json"
		}).then((response) => {
			if (!response || response.success === false) {
				return $.Deferred().reject(response && response.message || "Unknown error");
			}

			return response.data;
		});
	}

	function announce(msg) {
		var live = document.getElementById('sr-status');
		if (!live) return;
		live.textContent = '';
		setTimeout(function () { live.textContent = msg || ''; }, 10);
	}

	function setCheckingIndicator(inputId, isOn) {
		var el = document.getElementById(inputId);
		if (!el) return;
		var wrapper = el.closest(".field-wrapper") || el.parentElement;
		if (wrapper) {
			   wrapper.classList.toggle("is-checking", !!isOn);
			   wrapper.setAttribute('aria-busy', isOn ? 'true' : 'false');
			 }
		 if (isOn) {
			  var label = document.querySelector('label[for="' + inputId + '"]');
			   announce('Checking ' + (label ? label.textContent.trim() : inputId) + '…');
		  }
	}

	function loadCatalog($slider) {
		const productKey = $slider.data("product");
		const addonKey = $slider.data("proprietor-addon");
		const databaseCategoryKey = $slider.data("database-category");

		return $.when(
			fetchProduct(productKey),
			fetchProduct(addonKey),
			fetchCategory(databaseCategoryKey)
		).done(function (root, addon, databases) {
			if (root) {
				viewModel.soloCatalog.product(new Product(root));
			}

			if (addon) {
				viewModel.soloCatalog.addon(new Product(addon));
			}

			if (Array.isArray(databases)) {
				viewModel.soloCatalog.databases(databases.map((database) => new Product(database)));
			}
		}).fail((message) => {
			App.Base.ShowError(message);
		});
	}

	function checkUsername(username) {
		return $.ajax({
			url: `/api/contact/check_username`,			
			method: 'GET',
			dataType: 'json',
			data: { username } 
		});
	}

	function checkEmail(email) {
		return $.ajax({
			url: `/api/contact/check_email`,	
			method: 'GET',
			dataType: 'json',
			data: { email } 
		});
	}
	function createInitBinding(baseName, readInitial) {
		ko.bindingHandlers[baseName + "Init"] = {
			init: (element, valueAccessor, allBindings, viewModel, ctx) => {
				const target = valueAccessor();

				if (ko.isObservable(target))
					target(readInitial(element));

				ko.bindingHandlers[baseName].init(element, () => target, allBindings, viewModel, ctx);
			},
			update: (element, valueAccessor, allBindings, viewModel, ctx) =>
				ko.bindingHandlers[baseName].update(element, valueAccessor, allBindings, viewModel, ctx)
		};
	}

	function formatCurrency(value, currency, locale) {
		return new Intl.NumberFormat(locale || "en-US", {
			style: "currency",
			currency: currency || "USD"
		}).format(Number(value || 0));
	}

	function debouncedAvailabilityCheck(options) {
		const {
			observable,
			minLength = 1,
			inputId,
			requestFn,
			xhrKey,
			inUseMessage
		} = options;

		var debounced = observable.extend({
			rateLimit: { timeout: 400, method: "notifyWhenChangesStop" }
		});

		debounced.subscribe(function (currentValue) {
			if (viewModel.net[xhrKey]) {
				viewModel.net[xhrKey].abort();
				viewModel.net[xhrKey] = null;
			}

			applyCustomValidity(inputId, "");
			setCheckingIndicator(inputId, false);

			var v = (currentValue || "").trim();
			if (v.length < minLength) return;

			var token = v;
			setCheckingIndicator(inputId, true);

			viewModel.net[xhrKey] = requestFn(token)
				.done(function (res) {
					if (token !== (observable() || "").trim()) return;
					var available = res && res.data === "AVAILABLE";
					applyCustomValidity(inputId, available ? "" : inUseMessage);
				})
				.fail(function () {

				})
				.always(function () {
					if (token === (observable() || "").trim())
						viewModel.net[xhrKey] = null;

					setCheckingIndicator(inputId, false);
				});
		});
	}

	function applyCustomValidity(inputId, message) {
		var el = document.getElementById(inputId);
		if (!el) return;

		if (el.setCustomValidity)
			el.setCustomValidity(message || "");

		var hasError = !!message;
		el.setAttribute("aria-invalid", String(hasError));
		el.classList.toggle("is-invalid", hasError);

		
		var msg = null;
		var describedby = el.getAttribute("aria-describedby");
		if (describedby) msg = document.getElementById(describedby);

		
		if (!msg && el.previousElementSibling?.classList?.contains("field-validation-error")) {
			msg = el.previousElementSibling;
		} else if (!msg) {
			msg = (el.closest(".field-wrapper") || document).querySelector(".field-validation-error");
		}

		if (msg) msg.textContent = message || "";

		validityPulse(validityPulse() + 1);
		if (inputId === 'registration-username' || inputId === 'registration-email') {
			  var label = document.querySelector('label[for="' + inputId + '"]');
			  var name = label ? label.textContent.trim() : inputId;
			 announce(hasError ? (name + ': ' + message) : (name + ' looks good.'));
		 }
	}


	function init() {
		const $slider = $("#solo-access-step-slider");
		if (!$slider.length)
			return;

		var $panel = $slider.find(".step-administrative-database-subscription");
		var visibleCount = Number($panel.data("visible-count")) || null;
		if (visibleCount) viewModel.ui.databasesVisibleCount(visibleCount);

		createInitBinding("value", el => el.value);
		createInitBinding("checked", el => el.checked);

		ko.applyBindings(viewModel, $slider[0]);
		loadCatalog($slider);

		debouncedAvailabilityCheck({
			observable: viewModel.form.username,
			minLength: 3,
			inputId: "registration-username",
			requestFn: checkUsername,
			xhrKey: "usernameXhr",
			inUseMessage: "User name is in use."
		});

		debouncedAvailabilityCheck({
			observable: viewModel.form.email,
			minLength: 1,
			inputId: "registration-email",
			requestFn: checkEmail,
			xhrKey: "emailXhr",
			inUseMessage: "Email is in use."
		});
	}

	return { init };

})(jQuery, ko);

$(function () {
	App.SoloAccess.init();
});